import axios from 'axios'
import { serverURL } from '../utils/consts'

let authToken = null

export const getAuthToken = () => authToken
export const setAuthToken = (token) => {
  authToken = token
}

const API = axios.create({
  baseURL: serverURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

API.interceptors.request.use((config) => {
  if (authToken) config.headers.Authorization = `Bearer ${authToken}`
  return config
})

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      authToken = null
      const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
      const loginPath = prefix ? `${prefix}/login` : '/login'
      if (window.location.pathname !== loginPath) {
        window.location.href = loginPath
      }
    }
    return Promise.reject(err)
  }
)

export { API }
